export default "__VITE_ASSET__S$oUOui8__"